<template>
<div>
    <loading :show-loading="showLoading" />
    <div class="pc">
        <div class="con-icon"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-head">
                <p>精彩视频</p>
            </div>
            <!-- 内容 -->
            <div class="con-main" :style="{height:pageHeight}">
                <div class="main">
                    <div class="one" v-for="(video,index) in videoList" :key="index"  @click="showVideoToast(video, video.title)">
                        <div class="video"><img :src="video.coverImageRealPath" alt=""></div>
                        <div class="video-bg"><img src="@/assets/newImages/hotNews/video-start.png" alt=""></div>
                        <div class="text"><p>{{video.title}}</p></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="cover-page1" v-if="pageCoverVideo" @click="closeVideoToast()"></div>
        <div class="cover-page-video" v-if="pageCoverVideo">
            <video :src="videoToastUrl" controls></video>
            <div class="close" @click="closeVideoToast()">×</div>
        </div> -->
        <videoModel v-if="isPc" :show="pageCoverVideo" :videoInfo="videoToastUrl" @closeModal="closeVideoToast"></videoModel>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>精彩视频</p></div>
            <!-- 内容 -->
            <div class="con-main">
                <div class="one" v-for="(video,index) in videoList" :key="index"  @click="showVideoToast(video, video.title)">
                    <div class="video">
                        <img :src="video.coverImageRealPath" alt="">
                        <div class="video-bg"></div>
                        <img class="play" src="@/assets/newImages/hotNews/video-start.png" alt="">
                    </div>
                    <div class="text"><p>{{video.title}}</p></div>
                </div>
            </div>
        </div>
        <!-- <div class="cover-page" v-if="pageCoverVideo" @click="closeVideoToast()"></div>
        <div class="cover-page-video" v-if="pageCoverVideo">
            <video :src="videoToastUrl" controls></video>
            <div class="close" @click="closeVideoToast()">×</div>
        </div> -->
        <videoModel v-if="!isPc" :show="pageCoverVideo" :videoInfo="videoToastUrl" @closeModal="closeVideoToast"></videoModel>
    </div>
</div>
    
</template>
<script>
import api from '../api';
import videoModel from 'components/video-modal';
import loading from 'components/loading';
export default {
    components: {videoModel, loading},
    computed:{
        isPc(){
            return this.$store.state.isPc;
        },
    },
    data(){
        return{
            pageHeight:'',
            height:document.documentElement.clientHeight,
            width:document.documentElement.clientWidth,
            pageCoverVideo:false,
            videoList:[],
            videoToastUrl: '',
            showLoading: true,
        }
    },
    created(){
        this.pageHeight = this.height-187/1920*this.width-63/1920*this.width+"px"
        this.getVideoList();
    },
    mounted(){
        let self = this;
        this.$nextTick(() => {
            self.showLoading = false;
        })
    },
    methods:{
            showVideoToast(url, name){
                // 埋码
                this.$maima.ireview_page_video_click(name);

                this.pageCoverVideo = true;
                this.videoToastUrl = url;
            },
            closeVideoToast(){
                this.pageCoverVideo = false;
                this.videoToastUrl = '';
            },
            // 精彩视频
            getVideoList(){
                let that = this;
                api.getWonderfulVideoList()
                .then(res=>{
                    if(res){
                        that.videoList = res;
                    }
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
    }
}
</script>
<style scoped lang="scss">
*{  
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
    .content{
        width: pxToVw(1600);
        margin: pxToVw(0) pxToVw(0) 0 pxToVw(233);
        padding-top: pxToVw(49);
        position: relative;
        z-index: 2;
        .con-head{
            width: 100%;
            height: pxToVw(115);
            text-align: left;
            display: flex;
            justify-content: space-between;
            p{  
                width: pxToVw(351);//315
                height: pxToVw(115);//103
                padding: pxToVw(39) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        .con-main{
            // width: 1520px;
            // width: pxToVw(1520);
            // height: pxToVw(774);
            margin: pxToVw(23) pxToVw(0) pxToVw(0) pxToVw(63);
            padding-right: pxToVw(18);
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
             /*滚动条样式*/
            &::-webkit-scrollbar{
                    width: 3px;
                    height: pxToVw(863);
                    // background: #bbb;
                }
                &::-webkit-scrollbar-track{
                    // background: #bbb;
                    background: transparent;
                }
                &::-webkit-scrollbar-thumb{
                    background: #DDDDDD;
                }
                .main{
                    height: 100%;
                    flex-wrap: wrap;
                    display: flex;
                    background: #FFFFFF;
                    box-shadow: 0px 0px pxToVw(24) 0px rgba(231,231,231,0.5);
                    border-radius: pxToVw(2);
                    padding: pxToVw(47) 0 pxToVw(31) pxToVw(40);
                    .one{
                        position: relative;
                        width: pxToVw(337);
                        height: pxToVw(303);
                        background: #FFFFFF;
                        box-shadow: 0px 0px 10px 0px rgba(235,235,235,0.5);//1435
                        border-radius: 0px 0px 2px 2px;
                        margin: pxToVw(0) pxToVw(28) pxToVw(21) pxToVw(0);
                        cursor: pointer;
                        &:nth-child(4n){
                            margin-right: 0;
                        }
                        .video{
                            width: pxToVw(337);
                            height: pxToVw(191);
                            img{
                                width: pxToVw(337);
                                height: pxToVw(191);
                            }
                        }
                        .video-bg{
                            position: absolute;
                            top: 0;
                            width: pxToVw(337);
                            height: pxToVw(191);
                            background: rgba(0, 0, 0, 0.2);
                            img{
                                margin: pxToVw(81) pxToVw(156);
                                width: pxToVw(24);
                                height: pxToVw(28);
                            }
                        }
                        .text{
                            height: pxToVw(116);
                            background: #FFFFFF;
                            box-shadow: 0px 0px 11px 0px rgba(235,235,235,0.5);
                            border-radius: 0px 0px 3px 3px;
                            padding: pxToVw(23) pxToVw(17) pxToVw(0) pxToVw(15);
                            p{
                                height: pxToVw(58);
                                font-size: pxToVw(19);
                                font-family: "FZLT-black";
                                font-weight: normal;
                                color: #333333;
                                line-height: pxToVw(29);
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
        }
        
    }
    .con-icon{
        position: absolute;
        right: 0;
        bottom: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: pxToVw(480);
            height: pxToVw(403);
        }
    }
    .cover-page1{
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        border-radius: 4px;
        cursor: pointer;
    }
    .cover-page-video{
        position: fixed;
        z-index: 1001;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: pxToVw(1280);
        height: pxToVw(720);
        video{
            width: pxToVw(1280);
            height: pxToVw(720);
            border: none;
        }
        .close{
            position: absolute;
            top: pxToVw(-70);
            right: 0;
            width: pxToVw(50);
            height: pxToVw(50);
            font-size: pxToVw(60);
            line-height: pxToVw(50);
            color: #FFF;
            cursor: pointer;
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/common/navWap/page-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                width: 100%;
                padding: 0 4.5vw 0 4.8vw;
                height: auto;
                flex-wrap: wrap;
                display: flex;
                .one{
                    width: 43.7vw;
                    height: 45.3vw;
                    background: #FFFFFF;
                    box-shadow: 0 0 1.1vw 0 rgba(235,235,235,0.5);
                    margin: 0 3.2vw 2.8vw 0;
                    cursor: pointer;
                    &:nth-child(2n){
                        margin-right: 0;
                    }
                    .video{
                        width: 43.7vw;
                        height: 24.5vw;
                        position: relative;
                        img{
                            width: 43.7vw;
                            height: 24.5vw;
                        }
                        .video-bg{
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            background: rgba(0, 0, 0, 0.2);
                        }
                        .play{
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 3.2vw;
                            height: 3.7vw;
                        }
                    }
                    .text{
                        width: 100%;
                        height: 20.8vw;
                        padding: 3.1vw 2.3vw 0 2vw;
                        p{
                            font-size: 3.5vw;
                            line-height: 5.3vw;
                            color: #333333;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
        .cover-page{
            position: fixed;
            width: 100vw;
            height: 100vh;
            z-index: 100;
            top: 0;
            left: 0;
            background: rgba(0,0,0,0.5);
        }
        .cover-page-video{
            position: fixed;
            z-index: 101;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 82.4vw;
            height: 46.35vw;
            video{
                width: 82.4vw;
                height: 46.35vw;
                border: none;
            }
            .close{
                position: absolute;
                top: -6vw;
                right: 0;
                width: 5vw;
                height: 5vw;
                font-size: 6vw;
                text-align: center;
                line-height: 5vw;
                color: #FFF;
            }
        }
    }
}
</style>
